import {
  DEFAULT_MODEL_REF,
  DEFAULT_MODEL_REF_ARRAY,
  POSSIBLE_PRODUCTS,
} from 'consts';
import { isOn } from 'util/index';

export const combinerProducts = (fspConfigPal) => {
  if (!fspConfigPal) return DEFAULT_MODEL_REF_ARRAY;
  return (
    POSSIBLE_PRODUCTS.map(({ type, ...props }) => ({
      enabled: isOn(fspConfigPal[type]),
      type,
      ...props,
    })) ?? DEFAULT_MODEL_REF_ARRAY
  );
};
export const combinerSelectorArray = (r) => r ?? DEFAULT_MODEL_REF;
export const filterByFSPId = ({ FspConfigPayALoan }, fspId) => {
  return FspConfigPayALoan.filter((r) => r.fspId === fspId)?.last()?.ref;
};
